import React from "react";
import styles from "../CustomReportsForm.module.sass";
import { Checkbox } from "colbi_web_ui/lib/components/inputs";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { DescriptionsLocales } from "../../../../../components";
import CustomReportCondition from "../../CustomReportCondition";

const HeadersTab = ({ ReportName, Active, DefaultCondition, Metadata, handleChange }) => {
    const { i18n } = useGlobalValue();

    return (
        <div className={styles["headers"]}>
            <div className={styles["group-content"]}>
                <DescriptionsLocales
                    handleChange={handleChange}
                    jsonObject={ReportName}
                    keyToChange={"ReportName"}
                    inputTitle={"Custom report name"}
                    inputPlaceholder={"Enter a name for custom report"}
                />
            </div>

            <CustomReportCondition DefaultCondition={DefaultCondition} Metadata={Metadata} handleChange={handleChange} attributeName="DefaultCondition" isToShowConditionsFieldds={true}/>

            <div className={styles["group-content"]}>
                <div className={styles["flex"]}>
                    <div className={styles["input-field"]}>
                        <Checkbox
                            style={{ marginTop: "30px" }}
                            value={Active}
                            onChange={(e) => {
                                handleChange(e, "Active", e.target.checked ? 1 : 0);
                            }}
                        >{i18n`Active`}</Checkbox>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeadersTab;
